import { PaymentsService } from '@/services/payments.service'

import { currecyFormat } from '@/mixins/currency'
import { fromDate } from '@/mixins/formatDateTime'

import { datetime } from '@/config'

export async function setUnhandledPayment() {
  try {
    const result = await this.$swal.fire({
      title: 'Вы уверены?',
      html: `
        <div style="margin-bottom: 10px">
          <div>Дата: ${fromDate(this.row.created_at, datetime.FORMAT_DATETIME)}</div>
          <div>Сумма, ₽: ${currecyFormat(this.row.amount)}</div>
          <div>Назначение: ${this.row.paymentPurpose}</div>
          <div>Контрагент: ${this.row.contragentName}</div>
        </div>

        <div style="font-weight: bold">Аккаунт: ${this.application}</div>
      `,
      showCancelButton: true,
      confirmButtonText: 'Пополнить',
      showLoaderOnConfirm: true,
      customClass: { confirmButton: 'is-success' },
      preConfirm: () => {
        return PaymentsService.setUnhandledPayment({
          id: this.row.id,
          application: this.application,
        }).catch((error) => {
          this.$store.commit('toast/NEW', { type: 'error', message: error.message })

          return false
        })
      },
      allowOutsideClick: !this.$swal.isLoading,
    })

    if (result.isConfirmed) {
      this.$store.dispatch('payments/getUnlinkedCount')
      this.$store.commit('toast/NEW', { type: 'success', message: 'Операция выполнена.' })
      this.$emit('refreshTable')
    }
  } catch (e) {
    this.$store.commit('toast/NEW', { type: 'error', message: e.message, e })
    this.error = e.message
  }
}

export async function delPayment() {
  try {
    const result = await this.$swal.fire({
      title: 'Вы уверены?',
      html: `
        <div style="margin-bottom: 10px">
          <div>Дата: ${fromDate(this.row.created_at, datetime.FORMAT_DATETIME)}</div>
          <div>Сумма, ₽: ${currecyFormat(this.row.amount)}</div>
          <div>Назначение: ${this.row.paymentPurpose}</div>
          <div>Контрагент: ${this.row.contragentName}</div>
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: 'Удалить',
      showLoaderOnConfirm: true,
      customClass: { confirmButton: 'is-danger' },
      preConfirm: () => {
        return PaymentsService.delPayment({ id: this.row.id }).catch((error) => {
          this.$store.commit('toast/NEW', { type: 'error', message: error.message })

          return false
        })
      },
      allowOutsideClick: !this.$swal.isLoading,
    })

    if (result.isConfirmed) {
      this.$store.dispatch('payments/getUnlinkedCount')
      this.$store.commit('toast/NEW', { type: 'success', message: 'Операция выполнена.' })
      this.$emit('refreshTable')
    }
  } catch (e) {
    this.$store.commit('toast/NEW', { type: 'error', message: e.message, e })
    this.error = e.message
  }
}
